import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from "moment";

import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';

import { connect } from 'react-redux';
import { compose } from "recompose";

const formatter1 = 'YYYY-MM-DD';

const styles = theme => ({
    paper: {
        position: 'absolute',
        width: '80%',
        [theme.breakpoints.down('sm')]: {
            height: '90%',
            overflow: 'scroll',
        },
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    title: {
        flex: '0 0 auto',
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    textField: {
        width: '90%',
        margin: theme.spacing.unit,
    },
    setMarginBottom: {
        marginBottom: `${theme.spacing.unit * 3}px`,
    },
    button: {
        margin: theme.spacing.unit,

    },
});

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

class ReadOnlyFormComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            mode: 'ADD',
            open: false,
            modalTitle: '',

            timesheetId: '',
            date: '',
            hours: '',
            projectId: '',
            taskId: '',
            subCategoryId: '',
            taskNotes: '',
            value: '', //satisfaction
        };
    }

    componentWillReceiveProps(nextProps) {
        const timesheet = nextProps.timesheet;

        if (nextProps.TimesheetId) {
            var timesheetData = timesheet.items && timesheet.items.find(function (item, index, array) {
                return item.TimesheetId === nextProps.TimesheetId;
            });

            this.setState({
                timesheetId: timesheetData.TimesheetId,
                date: timesheetData.Date,
                hours: timesheetData.Hours,
                projectName: timesheetData.ProjectName,
                taskName: timesheetData.TaskName,
                subCategoryName: timesheetData.SubCategoryName,
                notes: timesheetData.Notes,
                value: timesheetData.Satisfaction
            })
        }
    }

    handleClose = () => {
        this.props.close()
    }

    render() {
        const { classes } = this.props;

        return (
            <Paper>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.props.open}
                    onClose={this.handleClose}
                >
                    <div style={getModalStyle()} className={classes.paper}>
                        <Typography id="modal-title" style={{ fontSize: 40 }}>
                            Timesheet
                            </Typography>
                        <Grid container>
                            <Grid item sm={12} md={5}>
                                <Grid container>
                                    <Grid item sm={12} md={6}>
                                        <Typography style={{ color: '#d89797' }}>Date</Typography>
                                        <Typography variant="h6"> {moment(this.state.date).format(formatter1)} </Typography>
                                    </Grid>

                                    <Grid item sm={12} md={6}>
                                        <Typography style={{ color: '#d89797' }}>Hour (s)</Typography>
                                        <Typography variant="h6">{this.state.hours}</Typography>
                                    </Grid>

                                    <Grid item sm={12} md={12}>
                                        <Typography style={{ color: '#d89797', paddingTop: '10px' }}>SubCategoryName</Typography>
                                        <Typography variant="h6">{this.state.subCategoryName}</Typography>
                                    </Grid>

                                    <Grid item sm={12} md={12}>
                                        <Typography style={{ color: '#d89797', paddingTop: '10px' }}>ProjectName</Typography>
                                        <Typography variant="h6">{this.state.projectName}</Typography>
                                    </Grid>

                                    <Grid item sm={12} md={12}>
                                        <Typography style={{ color: '#d89797', paddingTop: '10px' }}>TaskName</Typography>
                                        <Typography variant="h6">{this.state.taskName}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item sm={12} md={7}>
                                <TextField
                                    multiline
                                    disabled
                                    id="standard-multiline-static"
                                    label="Notes"
                                    rows="10"
                                    className={classes.textField}
                                    value={this.state.notes}
                                    margin="normal"
                                    variant="outlined"
                                />
                            </Grid>
                        </Grid>
                        <Typography style={{ color: '#d89797', paddingTop: '10px' }}>Task Satisfaction</Typography>
                        <BottomNavigation
                            value={this.state.value}
                            showLabels
                            className={classes.setMarginBottom}
                            color="secondary"
                        >
                            <BottomNavigationAction label="Tears of Joy" icon={<span role="img" aria-label="100">😂😂😂</span>} />
                            <BottomNavigationAction label="Grinning" icon={<span role="img" aria-label="80">😄😄</span>} />
                            <BottomNavigationAction label="Smiling" icon={<span role="img" aria-label="60">😊</span>} />
                            <BottomNavigationAction label="Thinking" icon={<span role="img" aria-label="50">🤔</span>} />
                            <BottomNavigationAction label="Out of sorts" icon={<span role="img" aria-label="40">😠</span>} />
                            <BottomNavigationAction label="Angry" icon={<span role="img" aria-label="20">😤😤</span>} />
                            <BottomNavigationAction label="Very Angry" icon={<span role="img" aria-label="0">😡😡😡</span>} />
                        </BottomNavigation>

                        <Button variant="outlined" className={classes.button} onClick={this.handleClose}>
                            Cancel
                        </Button>
                    </div>
                </Modal>
            </Paper>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { timesheet } = state;

    return {
        user,
        timesheet
    };
}

ReadOnlyFormComponent.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles))(ReadOnlyFormComponent);


// WEBPACK FOOTER //
// ./src/components/Timesheet/ReadOnlyFormComponent.js